import * as angular from "angular";

angular
  .module('bringoz.admin.terms', [])
  .config(TermsConfig);

/* @ngInject */
function TermsConfig($stateProvider) {

  $stateProvider
    .state('terms', {
      parent: 'bringoz.site',
      url: '/administration/policy',
      template: '<app-terms-view></app-terms-view>',
      controller: function (triBreadcrumbsService) {
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Policy"});
        triBreadcrumbsService.addCrumb({name: "Configurations"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    });

}
